export default __webpack_public_path__ + "static/media/soccerball.45a42355.png";